import axios from 'axios';
import { getDeviceType } from '../utils/functions/getDeviceType';

import { getStrapiURL } from '../lib/api';
const apiBaseUrl = getStrapiURL();
import SiteHeader from '../components/shared/SiteHeader';

import {
  WhyCoach,
  Card,
  NotAlone,
  EarningPotential,
  CoachesAtAlmaBetter,
  HowItWorks,
} from '../components/local/become-a-coach';
import { COACH_SIGNUP } from '../lib/constants';

export default function BecomeACoach({ coaches, coachData }) {
  const deviceType = getDeviceType();
  return (
    <>
      <SiteHeader
        title={coachData?.seo?.MetaTitle}
        desc={coachData?.seo?.MetaDescription}
        url={coachData?.seo?.MetaUrl}
        image={coachData?.seo?.image?.data?.attributes?.url}
      />
      <div className="container-default-1209px">
        <Card
          title="Coach the next gen Tech Talent."
          desc="Become a coach with AlmaBetter to help next generation tech talent
          acquire in-demand skills and kickstart their careers."
          buttonText="Become a coach"
          bgColor="bg-red"
          text="text-white"
          buttonLink={COACH_SIGNUP}
          img="/assets/images/become-a-coach/Group 10000023063x.png"
          isHeroCard={true}
        />
        <WhyCoach />
        <CoachesAtAlmaBetter />

        <EarningPotential />
        <NotAlone coaches={coaches} deviceType={deviceType} />
        <div className="my-12 flex flex-col items-center">
          <h2 className="heading-2 mb-4 text-center lg:text-left">What our Coaches are saying</h2>
          <div
            className="mb-10 mt-5 flex flex-col items-center rounded-md p-8 lg:flex-row"
            style={{
              background: 'linear-gradient(124.35deg, #FFEEDF 29.7%, #FEF6ED 74.19%)',
            }}
          >
            <img
              src="/assets/images/become-a-coach/Ekta.png"
              alt=""
              className="rounded-lg lg:mr-8 lg:h-[284px] lg:w-6/12"
            />
            <div className="mt-5 lg:mt-0 lg:pr-12">
              <p className="text-para text-xl">
                “I’m proud to wake up knowing my work is helping aspiring students improve their
                careers and build great things. Mentoring with a fulltime job can be hectic but
                AlmaBetter team and processes makes it easy and flexible.”
              </p>
              <div className="mt-4 font-satoshi-bold text-base font-bold ">Ekta Maheshwarii</div>
              <div className="font-satoshi-bold text-base font-bold  text-red">
                Lead Data Scientist, Accenture Baltics
              </div>
            </div>
          </div>
        </div>
        <div className="mx-5 mb-32 flex flex-col items-start justify-between lg:mx-0 lg:flex-row lg:items-center">
          <div className="flex w-full flex-col items-center justify-evenly text-left lg:w-[50%] lg:items-start">
            <h2 className="heading-2 mb-5 text-center lg:w-[90%] lg:text-left">
              Our coaches are our superheroes. Wear your cape today.
            </h2>

            <a
              href={COACH_SIGNUP}
              className={`text-md mt-2 w-fit cursor-pointer rounded-lg border border-red bg-white py-4 px-12 font-satoshi-medium font-semibold uppercase text-red md:text-lg`}
            >
              <div>Become a coach</div>
            </a>
          </div>
          <div className={`mt-5 w-full lg:mt-0 lg:w-6/12`}>
            <img
              src={'/assets/images/become-a-coach/Group 10000023153x.png'}
              alt=""
              // className='lg:-ml-[150px]'
            />
          </div>
        </div>
      </div>
    </>
  );
}
export async function getStaticProps(context) {
  try {
    const res = await axios.get(
      `${apiBaseUrl}/api/career-coaches?populate=DisplayPicture&populate=CompanyImage`
    );
    const { data } = await axios.get(`${apiBaseUrl}/api/become-a-coach?populate=seo.image`);
    return {
      props: { coaches: res.data.data || [], coachData: data.data.attributes },
      revalidate: 3600,
    };
  } catch (error) {
    return { props: { error: error.message } };
  }
}
